import { createDboxPluginStoreConfig } from "../dboxstore/dboxstore";

export const createDboxCostConfig = ({
  // storeNamesPace = 'CatalogStore',
  // detailsAction = 'ProductDetails',
  // detailsGetterKey = 'productDetails',
  // itemsKey = 'costs',
  // primaryKeyValue = '12345',

  storeNamesPace = 'CatalogStore',
  detailsAction = 'ProductDetails',
  detailsGetterKey = 'productDetails',
  dataKey = 'costs',
  primaryKeyValue = '12345',
  
  externalTable = 'release',
}) => {
  return {
    storeNamesPace,
    detailsAction,
    detailsGetterKey,
    dataKey,
    primaryKeyValue,
    externalTable,
  }
}


export const getCostStatus = (status) => {
  switch (status) {
    case "Open Advance": {
      return "open_advance";
    }
    case "Not Recoupable": {
      return "not_recoupable"
      break;
    }
    case "Do not Recoup": {
      return "do_not_recoup"
      break;
    }
    default: {
      if (status.startsWith("Accounted:")) {
        return "accounted";
      } else {
      }
    }
  }
}
